import {
  AppBase,
  baseFromDoc,
  FirestoreBaseDoc,
  makeDocConverter,
} from '../../base/firestore-model-base'
import type { SchoolAccountDoc } from './school-account.modl'

/**
 * SchoolAccountHistory（学校アカウント変更履歴）
 *
 * `school_accounts/{schoolAccountId}/history/{historyId}`
 */

export type SchoolAccountHistoryDoc = FirestoreBaseDoc & {
  school_account: SchoolAccountDoc & { document_id?: string }
  updated_by_user_type: 'admin' | 'school'
  updated_by_user_id: string
  updated_by_name: string
  updated_by_user_document_path: string
  update_info?: string | null
}

export type SchoolAccountHistoryEntity = AppBase & {
  school_account: SchoolAccountDoc & { document_id?: string }
  updated_by_user_type: 'admin' | 'school'
  updated_by_user_id: string
  updated_by_name: string
  updated_by_user_document_path: string
  update_info?: string | null
}

export const schoolAccountHistoryDocConverter = makeDocConverter<SchoolAccountHistoryDoc>()

export function toSchoolAccountHistoryEntity(
  id: string,
  doc: SchoolAccountHistoryDoc,
  path: string,
): SchoolAccountHistoryEntity {
  return {
    ...baseFromDoc(id, doc, path),
    school_account: doc.school_account,
    updated_by_user_type: doc.updated_by_user_type,
    updated_by_user_id: doc.updated_by_user_id,
    updated_by_name: doc.updated_by_name,
    updated_by_user_document_path: doc.updated_by_user_document_path,
    update_info: doc.update_info ?? null,
  }
}

